<tec-modal
	[isVisible]="isVisible"
	[type]="'confirmation'"
	[buttonPrimaryLabel]="'GENERAL.BUTTON.OK' | translate"
	(closeEvent)="closeModal()"
>
	<ng-container body>
		<tec-tag-icon [size]="'default'" [icon]="'icon-alert'"></tec-tag-icon>
		<div class="body__text">
			<h4>{{ 'DOCUMENTS.PENDING.TITLE' | translate }}</h4>
			<span>{{ 'DOCUMENTS.PENDING.DESCRIPTION' | translate }}</span>
		</div>
	</ng-container>
</tec-modal>
